import { render, staticRenderFns } from "./GroupChatLogDetail.vue?vue&type=template&id=bbeca58e&scoped=true&"
import script from "./GroupChatLogDetail.vue?vue&type=script&lang=js&"
export * from "./GroupChatLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatLogDetail.vue?vue&type=style&index=0&id=bbeca58e&scoped=true&lang=css&"
import style1 from "./GroupChatLogDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeca58e",
  null
  
)

export default component.exports